import styled from 'styled-components/macro'
import { theme, prop } from 'styled-tools'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border: 0;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.15);
  width: 100%;
  min-height: 50px;
  border-radius: 5px;
  padding: 0.5em;
  font-size: 80%;
  background: ${theme('productBoxBackground')};
  &:hover {
    box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.22);
  }
`

const SocialMediaSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5em;
  height: ${prop('height')};
  p {
    font-size: 16px;
    margin: 0;
    padding-left: 8px;
  }
  div {
    display: flex;
    align-items: center;
  }
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1em;
`

const HausMartName = styled.h4`
  margin-top: 5px;
`

const HausMartDescription = styled.div``

const SocialIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
  background: ${theme('productPlusButtonBackground', 'black')};
  width: 32px;
  color: ${theme('productPlusButtonIcon', 'black')} !important;
  font-size: 125%;
  &:before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`

const CardTitle = styled.span`
  color: ${theme('lightGray')};
  position: absolute;
  top: 0.5em;
  right: 1em;
  text-transform: uppercase;
`

export { Card, CardTitle, SocialMediaSection, InfoSection, HausMartName, HausMartDescription, SocialIcon }
